module.exports = __webpack_public_path__ + "img/svg/multiplayer-competition-card-hover.35e22de0ca810c83fee2c0535c2b9f20.svg";